import zh from "./zh.json";

const json = {...zh};

export default json;
